import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Rol } from 'src/app/core/interfaces/user.interface';
import { FormInitialaizerFactory } from '../../../services/form-initializer-factory';
import { GetCompanyCuilUseCase } from 'src/app/features/company/domain/usecases/get-company-colective.usecase';

@Component({
  selector: 'app-step-company-cuil',
  templateUrl: './step-company-cuil.component.html',
  styleUrls: ['./step-company-cuil.component.css'],
})
export class StepCompanyCuilComponent implements OnInit {
  @Input() initialData: any = {};
  @Output() company: EventEmitter<FormGroup> = new EventEmitter();
  @Output() companySearch: EventEmitter<FormGroup> = new EventEmitter();
  @Output() back: EventEmitter<number> = new EventEmitter();
  @Input() selectedRol!: Rol;

  registerFormCompany: FormGroup = this.formBuilder.group({});
  formCompany: FormGroup = this.formBuilder.group({});

  constructor(
    private formBuilder: FormBuilder,
    private formInitializerFactory: FormInitialaizerFactory,
    private getCompanyUseCase: GetCompanyCuilUseCase
  ) {}

  ngOnInit() {
    this.initForm();
    if (this.initialData) {
      this.registerFormCompany.patchValue(this.initialData);
    }
  }

  nextStep() {
    this.companySearch.emit(this.formCompany.value);
    this.company.emit(this.registerFormCompany.value);
  }

  previusStep() {
    this.back.emit(1);
  }

  async searchForCuit() {
    if (this.registerFormCompany.get('cuit')?.invalid) return;

    const cuit = this.registerFormCompany.get('cuit')?.value;
    const cuitLimpio = cuit.replace(/-/g, '');

    try {
      const result = await this.getCompanyUseCase.execute(cuitLimpio);
      if (result && 'razon_social' in result) {
        this.formCompany = this.formBuilder.group({
          razon_social: [result.razon_social || ''],
          cuit: [cuitLimpio || ''],
          phone: [result.phone || ''],
          province: [result.province || ''],
          province_id: [result.province_id || ''],
          city: [result.city || ''],
          street: [result.street || ''],
          number: [result.number || ''],
          floor_apartment: [result.floor_apartment || ''],
          postal_code: [result.postal_code || ''],
          email: [result.email || ''],
          tower: [result.tower || ''],
          neighborhood: [result.neighborhood || ''],
        });
      } else {
        console.error('No se encontró la empresa con el CUIT proporcionado.');
        this.formCompany = this.formBuilder.group({});
      }
    } catch (error) {
      console.error(
        'Ocurrió un error al buscar la información. Por favor, intente nuevamente o complete los datos manualmente.'
      );
      this.formCompany = this.formBuilder.group({});
    }

    this.nextStep();
  }

  hasErrors(controlName: string, errorType: string) {
    return (
      this.registerFormCompany.get(controlName)?.hasError(errorType) &&
      this.registerFormCompany.get(controlName)?.touched
    );
  }

  initForm(): void {
    let formInitializer = this.formInitializerFactory.getFormInitializer(
      this.selectedRol
    );
    this.registerFormCompany = formInitializer();
  }
}
